module.exports = __webpack_public_path__ + "img/travel_tiger_advert.17093beb.webp";